var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCreate6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 15.1113,
    y: 12.2773,
    width: 12.2778,
    height: 13.2222,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.334 8.4974H17.0007L15.0032 6.4999C14.4648 5.96156 13.7423 5.66406 12.9915 5.66406H5.66732C4.09482 5.66406 2.84815 6.9249 2.84815 8.4974L2.83398 25.4974C2.83398 27.0699 4.09482 28.3307 5.66732 28.3307H28.334C29.8923 28.3307 31.1673 27.0557 31.1673 25.4974V11.3307C31.1673 9.7724 29.8923 8.4974 28.334 8.4974ZM25.5007 19.8307H22.6673V22.6641C22.6673 23.4432 22.0298 24.0807 21.2507 24.0807C20.4715 24.0807 19.834 23.4432 19.834 22.6641V19.8307H17.0007C16.2215 19.8307 15.584 19.1932 15.584 18.4141C15.584 17.6349 16.2215 16.9974 17.0007 16.9974H19.834V14.1641C19.834 13.3849 20.4715 12.7474 21.2507 12.7474C22.0298 12.7474 22.6673 13.3849 22.6673 14.1641V16.9974H25.5007C26.2798 16.9974 26.9173 17.6349 26.9173 18.4141C26.9173 19.1932 26.2798 19.8307 25.5007 19.8307Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCreate6);
export default __webpack_public_path__ + "static/media/icon-create-6.659d5695ff9502ba574201dd3e6dd03a.svg";
export { ForwardRef as ReactComponent };